module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "plm_hd"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/REV_genpref"
    }
  }, [_vm._v("General preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/REV_autpref"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/REV_abbrev"
    }
  }, [_vm._v("Chief abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/REV_structure"
    }
  }, [_vm._v("The structure of the drama")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/REV_intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/REV_ch01#sigil_toc_id_1"
    }
  }, [_vm._v("The prologue (1:1–8)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch02#sigil_toc_id_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene 1: The church in the world: "), _c('span', {
    staticClass: "italic2"
  }, [_vm._v("seven letters dictated")]), _vm._v(" (1:9 – 3:22)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch03#sigil_toc_id_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene 2: Suffering for the church: "), _c('span', {
    staticClass: "italic2"
  }, [_vm._v("seven seals opened")]), _vm._v(" (4:1 – 8:1)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch04#sigil_toc_id_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene 3: Warning for the world: "), _c('span', {
    staticClass: "italic2"
  }, [_vm._v("seven trumpets sounded")]), _vm._v(" (8:2 – 11:18)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch05#sigil_toc_id_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene 4: The drama of history: "), _c('span', {
    staticClass: "italic2"
  }, [_vm._v("seven visions of cosmic conflict")]), _vm._v(" (11:19 – 15:4)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch06#sigil_toc_id_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene 5: Punishment for the world: "), _c('span', {
    staticClass: "italic2"
  }, [_vm._v("seven bowls poured out")]), _vm._v(" (15:5 – 16:21)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch07#sigil_toc_id_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene 6: Babylon the whore: "), _c('span', {
    staticClass: "italic2"
  }, [_vm._v("seven words of justice")]), _vm._v(" (17:1 – 19:10)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch08#sigil_toc_id_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene 7: The drama behind history: "), _c('span', {
    staticClass: "italic2"
  }, [_vm._v("seven visions of ultimate reality")]), _vm._v(" (19:11 – 21:8)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch09#sigil_toc_id_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene 8: Jerusalem the bride: "), _c('span', {
    staticClass: "italic2"
  }, [_vm._v("seven final revelations")]), _vm._v(" (21:9 – 22:19)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch10#sigil_toc_id_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The epilogue (22:20–21)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_sg",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Study guide")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_OT",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bible Speaks Today: Old Testament series")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_NT",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bible Speaks Today: New Testament series")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_themes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bible Speaks Today: Bible Themes series")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_IVPtbs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IVP Academic Textbook Selector")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7967cb54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/REV_contents.vue
// module id = 66
// module chunks = 0